module.exports = __webpack_public_path__ + "img/20210902_151613.66221b11.jpg";